import React from 'react';
import './TaxiAtFixPage.css';

const TaxiAtFixPage = () => {
  return (
    <div className="TaxiAtFixPageContiner">
      <div className="TaxiAtFixPageContent">
        <h1 className="TaxiAtFixPageH1">בקרוב</h1>
        <h2 className='TaxiAtFixPageH2'> בקרוב יהיה פה שלל של מוניות פיקס ומוניות להשכרה </h2>
        <h4 className='TaxiAtFixPageH4'>לבינתיים היכנסו למאגר המוניות למכירה שלנו</h4>
        <button className="hero-button" onClick={() => window.location.href = '/AllTaxiYad2ForSalepage'}>למאגר המוניות</button>
      </div>
    </div>
  );
};

export default TaxiAtFixPage;
